<script lang="ts">
  import type { ISession } from '../api/entities';
  import { formatDate } from '../utils';

  export let session: ISession;
  export let nbAvailablePlaces;
</script>

  <div>
    <h3 class="wrapped">{session.name}</h3>
    <p class="hour">
      {formatDate(session.date, { withDate: true, withTime: true })}
    </p>
    <p class="wrapped">
    {session.description || ''}
  </p>
  <p class="wrapped">
      {#if session.nbPlaces > 0}
        {nbAvailablePlaces} places restantes sur {session.nbPlaces}
      {:else}
        &nbsp;
      {/if}
    </p>
  </div>


<style lang="scss">
  @import "../styles/bulma.override";

  $gap: 1rem;

  h3 {
    font-family: 'Indie Flower';
    font-size: 24px;
    letter-spacing: 0.05rem;
    color: $primary;
  }

  .hour {
    font-family: 'Indie Flower';
    font-weight: bold;
    font-size: 20px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  @include mobile {
    h3,
    p {
      margin: 8px 0;
    }
  }

  .wrapped {
    white-space: pre-wrap;
    word-break: break-word;
  }

</style>